import React from 'react';

import { CreateTemplate } from 'src/components/icons/GetStarted';
import { IntercomTour } from 'src/config';
import type { Apollo } from 'src/gql/generated';

import { useLaunchAiPlaybookTour } from './LaunchNda';
import { GenericAction } from '../StepAccordion';

export function GenerateAiPlaybook({ task }: { task: Apollo.OnboardingTask }) {
  const { launchAiPlaybookTour, loading } = useLaunchAiPlaybookTour();

  return (
    <GenericAction
      actionTitle="Generate an Aline AI playbook"
      image={<CreateTemplate />}
      loading={loading}
      text="Learn how to build an AI playbook from your own legal templates so you can have an AI playbook fully customized to your organization in minutes."
      onClick={async () => {
        await launchAiPlaybookTour(task, IntercomTour.generateAiPlaybook, {
          openExamplePlaybook: false,
        });
      }}
    />
  );
}
